module.exports = __webpack_public_path__ + "img/xiangmu8.a21b186a.png";